import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import defaultRestApi from '../common/RestApiInstance'
import APIs from '../common/APIs'
import querystring from 'query-string'
import { VIEW_STATUS } from '../components/StatsPageComponent/constants'

export const fetchTeamStatsData = createAsyncThunk(
    'TeamStats/fetchTeamStatsData',
    async (eventId) => {
        const params = {
            e: eventId
        }
        const response = await defaultRestApi.get(APIs.getTeamStatsURL(querystring.stringify(params)), {
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            }
        })
        return response.data
    }
)

const StatsSlice = createSlice({
    name: 'TeamStats',
    initialState: {
        e: [],
        lf: [],
        as: [],
        lt: [],
        viewStatus: VIEW_STATUS.LOADING,
        errorCode: "",
        isFromStatsPage: false
    },
    reducers: {
        resetStatsSlice: (state) => {
            state.e = []
            state.lf = []
            state.as = []
            state.lt = []
            state.viewStatus = VIEW_STATUS.LOADING
        },
        pendingTeamStatsData: (state) => {
            state.e = []
            state.lf = []
            state.as = []
            state.lt = []
            state.viewStatus = VIEW_STATUS.PENDING
        },
        updateIsFromStatsPage: (state, {payload}) => {
            state.isFromStatsPage = payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchTeamStatsData.pending, (state) => {
            state.e = []
            state.lf = []
            state.as = []
            state.lt = []
            state.viewStatus = VIEW_STATUS.LOADING
        })
        builder.addCase(fetchTeamStatsData.rejected, (state, action) => {
            state.viewStatus = VIEW_STATUS.ERROR
            state.errorCode = action.payload ? action.payload.error : ""
        })
        builder.addCase(fetchTeamStatsData.fulfilled, (state, action) => {
            state.e = action.payload.e || []
            state.lf = action.payload.lf || []
            state.as = action.payload.as || []
            state.lt = action.payload.lt || []
            state.viewStatus = VIEW_STATUS.TEAM
        })
    }
})

export const { resetStatsSlice , pendingTeamStatsData, updateIsFromStatsPage} = StatsSlice.actions
export default StatsSlice.reducer


// WEBPACK FOOTER //
// ./src/app/slices/StatsSlice.js